// @ts-nocheck
/**
 * Script to upload the RecruitLook logo to Supabase storage for email templates
 * Run this manually from the browser console or via a one-time admin action
 */

import { supabase } from '@/integrations/supabase/client';
import croppedRlLogo from '@/assets/cropped-rl-logo.png';

export const uploadEmailLogo = async () => {
  try {
    // Fetch the logo as a blob
    const response = await fetch(croppedRlLogo);
    const blob = await response.blob();
    
    // Upload to email-images bucket
    const { data, error } = await supabase.storage
      .from('email-images')
      .upload('recruitlook-logo.png', blob, {
        contentType: 'image/png',
        upsert: true, // Replace if exists
      });

    if (error) {
      console.error('Error uploading logo:', error);
      return { success: false, error };
    }

    console.log('Logo uploaded successfully:', data);
    return { success: true, data };
  } catch (error) {
    console.error('Failed to upload logo:', error);
    return { success: false, error };
  }
};

// If running directly in browser console:
// import { uploadEmailLogo } from '@/scripts/uploadEmailLogo';
// uploadEmailLogo().then(console.log);